// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"_419RD","rc-tabs-tab":"L2-XZ","rc-tabs-tab-active":"Jae5w","tip":"SK7+i","tip-label":"tPJrx","tip-group":"_9UJoh","empty":"OXsHr","message":"DboXL","content":"JVzwh"};